export const moveLocationSearchField = () => {
    if (!document.body.classList.contains("page-homepage")) return;

    const searchWidget: HTMLDivElement | null = document.querySelector(".page-homepage__hero-search");
    const inputs: HTMLDivElement | null = (searchWidget?.querySelector(".attrax-search-widget__form-items") ?? null);
    const location: HTMLDivElement | null = (searchWidget?.querySelector(".location-filter") ?? null);

    if (!inputs || !location || inputs.contains(location)) return;

    inputs.append(location);
};

export const handleSearchFilters = () => {
    if (!document.body.classList.contains('page-homepage') && (!document.body.classList.contains('page-jobs-near-you'))) return;

    cleanUpCustomFormMethods();

    initDropdown('.attrax-form-item__option-dropdown');

    document.addEventListener('click', (event) => {
        const target = event.target as HTMLElement;
        toggleInputDropdown(target);
        closeFilters(event);
    });
};

export const cleanUpCustomFormMethods = (): void => {
    document.addEventListener("click", (event: MouseEvent) => {
        const element: HTMLElement = event.target as HTMLElement;

        if (element.classList.contains("copoptions-input")) {
            event.preventDefault();

            const parent = element.closest(".attrax-form-item--attrax-options");
            const isOpen = parent?.classList.contains("isOpen") ?? false;
            const id = element.getAttribute("data-link-id");

            document.querySelectorAll(".copoptions-input").forEach((input) => {
                const inputParent = input.closest(".attrax-form-item--attrax-options");
                if (input.getAttribute("data-link-id") !== id) {
                    inputParent?.classList.remove("open");
                }
            });

            if (!isOpen) {
                triggerCustomEvent(element, "attrax.copoptions.before-show");

                const selectId = id?.replace(/-input-/gi, "-select-");

                document.querySelectorAll(".copoptions-select").forEach((dropdown) => {
                    if ((dropdown as HTMLElement).getAttribute("data-link-id") !== selectId) {
                        (dropdown as HTMLElement).style.display = "none";
                    }
                });

                const currentDropdown = document.querySelector(
                    `div[data-link-id='${selectId}']`
                ) as HTMLDivElement;

                if (currentDropdown) {
                    currentDropdown.style.display = "block";
                }

                parent?.classList.add("open");
                triggerCustomEvent(element, "attrax.copoptions.after-show");
            }
        }
    });
};

export const triggerCustomEvent = (element: HTMLElement, eventName: string): void => {
    const event = new CustomEvent(eventName, { bubbles: true, cancelable: true });
    element.dispatchEvent(event);
};

export const toggleInputDropdown = (target: HTMLElement): void => {
    if (target.classList.contains("copoptions-input")) {
        const parent = target.closest(".attrax-form-item--attrax-options");
        if (!parent) return;

        const id = target.getAttribute("data-link-id");
        const isOpen = parent.classList.contains("isOpen");

        document.querySelectorAll(".copoptions-input").forEach((input) => {
            const inputParent = input.closest(".attrax-form-item--attrax-options");
            if (input.getAttribute("data-link-id") !== id) {
                inputParent?.classList.remove("isOpen");
            }
        });

        isOpen ? parent.classList.remove("isOpen") : parent.classList.add("isOpen");
    }
};

export const closeFilters = (event: MouseEvent): void => {
    const target = event.target as HTMLElement;
    const isInsideDropdown = target.closest('.copoptions-input, .options, .copoption, .attrax-form-item__option-dropdown, .copoptions-select');

    if (target.classList.contains("copoptions-input")) {
        return;
    }

    if (isInsideDropdown) {
        event.stopPropagation();

        document.querySelectorAll('.attrax-form-item__option-dropdown, .copoptions-select').forEach((dropdown) => {
            (dropdown as HTMLElement).style.display = 'block';
        });

        if (target.closest(".copoption")) {
            target.closest(".attrax-form-item--attrax-options")?.classList.add("isOpen");
            return;
        }
    } else {
        document.querySelectorAll('.attrax-search-widget__form-items .attrax-form-item--attrax-options').forEach((active) => {
            if (active.classList.contains("isOpen")) {
                active.classList.remove('isOpen');
            }
        });

        document.querySelectorAll('.attrax-form-item__option-dropdown, .copoptions-select').forEach((dropdown) => {
            (dropdown as HTMLElement).style.display = 'none';
        });
    }
};

export const initDropdown = (fieldSelector: string): void => {
    const field = document.querySelector('.attrax-form-item__trigger-options') as HTMLInputElement;
    const parent = field?.parentElement;
    if (!parent) return;

    const options = parent.querySelector(`${fieldSelector} ol.options`) as HTMLUListElement;
    if (!options) return;

    const createDropdownButton = (element: HTMLLIElement, text: string, id: string): void => {
        const span = document.createElement('span');
        span.textContent = text;
        element.textContent = '';
        element.appendChild(span);

        const button = document.createElement('button');
        button.classList.add('dropdown__menu-icon');
        button.setAttribute('type', 'button');
        button.setAttribute('aria-label', `Toggle dropdown for ${text}`);
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', `dropdown-menu-${id}`);
        element.appendChild(button);
    };

    const allParents = options.querySelectorAll('li.has-children') as NodeListOf<HTMLLIElement>;
    allParents.forEach((parent) => {
        const id = parent.id;
        const text = parent.firstChild?.textContent?.trim() || '';
        createDropdownButton(parent, text, id);
    });

    const listCities = options.querySelectorAll('ol[data-parent-id]') as NodeListOf<HTMLOListElement>;
    listCities.forEach((city) => {
        const id = city.dataset.parentId || '';
        city.id = `dropdown-menu-${id}`;
        city.classList.add('dropdown__menu');
    });

    const listRegions = options.querySelectorAll('li[id]') as NodeListOf<HTMLLIElement>;
    listRegions.forEach((region) => {
        const id = region.id;
        const button = region.querySelector('.dropdown__menu-icon') as HTMLButtonElement | null;

        if (!id) return;

        button?.addEventListener('click', (e: MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();

            const dropdown = options.querySelector(
                `ol[data-parent-id='${id}']`
            ) as HTMLOListElement;
            const icon = region.querySelector('.dropdown__menu-icon') as HTMLButtonElement | null;

            if (dropdown && icon) {
                dropdown.classList.toggle('dropdown__menu--expanded');
                icon.classList.toggle('dropdown__menu-icon--expanded');
                icon.setAttribute(
                    'aria-expanded',
                    icon.classList.contains('dropdown__menu-icon--expanded') ? 'true' : 'false'
                );
            }
        });
    });
};